import { render, staticRenderFns } from "./Tousufankui.vue?vue&type=template&id=6930ca19&scoped=true"
import script from "./Tousufankui.vue?vue&type=script&lang=js"
export * from "./Tousufankui.vue?vue&type=script&lang=js"
import style0 from "./Tousufankui.vue?vue&type=style&index=0&id=6930ca19&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6930ca19",
  null
  
)

export default component.exports